import { render } from "./Login.vue?vue&type=template&id=5fc2ca16"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5fc2ca16&lang=css"
script.render = render

export default script